'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { breakpoints } from '../constants/breakpoints';
import { Breakpoint } from '../enums/breakpoint';
export const useBreakpoint = () => {
  const $ = _c(6);
  const [breakpoint, setBreakpoint] = useState(undefined);
  const isDesktop = breakpoint === Breakpoint.Medium || breakpoint === Breakpoint.Large || breakpoint === Breakpoint.XLarge;
  const isLargeDesktop = breakpoint === Breakpoint.Large || breakpoint === Breakpoint.XLarge;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mediaQueries = [{
        mediaQuery: window.matchMedia(`(max-width: ${breakpoints[Breakpoint.Small] - 1}px)`),
        size: Breakpoint.XSmall
      }, {
        mediaQuery: window.matchMedia(`(min-width: ${breakpoints[Breakpoint.Small]}px) and (max-width: ${breakpoints[Breakpoint.Medium] - 1}px)`),
        size: Breakpoint.Small
      }, {
        mediaQuery: window.matchMedia(`(min-width: ${breakpoints[Breakpoint.Medium]}px) and (max-width: ${breakpoints[Breakpoint.Large] - 1}px)`),
        size: Breakpoint.Medium
      }, {
        mediaQuery: window.matchMedia(`(min-width: ${breakpoints[Breakpoint.Large]}px)`),
        size: Breakpoint.Large
      }, {
        mediaQuery: window.matchMedia(`(min-width: ${breakpoints[Breakpoint.XLarge]}px)`),
        size: Breakpoint.XLarge
      }];
      const checkMatch = () => {
        for (const {
          mediaQuery,
          size
        } of mediaQueries) {
          if (mediaQuery.matches) {
            setBreakpoint(size);
          }
        }
      };
      for (const {
        mediaQuery: mediaQuery_0
      } of mediaQueries) {
        if (mediaQuery_0.addEventListener) {
          mediaQuery_0.addEventListener("change", checkMatch);
        } else {
          mediaQuery_0.addListener(checkMatch);
        }
      }
      checkMatch();
      return () => {
        for (const {
          mediaQuery: mediaQuery_1
        } of mediaQueries) {
          if (mediaQuery_1.removeEventListener) {
            mediaQuery_1.removeEventListener("change", checkMatch);
          } else {
            mediaQuery_1.removeListener(checkMatch);
          }
        }
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== breakpoint || $[3] !== isDesktop || $[4] !== isLargeDesktop) {
    t2 = {
      breakpoint,
      isDesktop,
      isLargeDesktop
    };
    $[2] = breakpoint;
    $[3] = isDesktop;
    $[4] = isLargeDesktop;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};